import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Page, FormGroup, SaveButton, PendingButton, required } from "components/common";
import { NotificationManager } from "react-notifications";
import styles from "assets/scss/fixed_assets.module.css";
import { Trans } from 'react-i18next';
import { Link } from "react-router-dom";
import { LocalForm, Control, actions, Errors } from "react-redux-form";
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Label } from 'reactstrap';
import BackButton from 'components/refactoring/BackButton';
import AddAssetType from "./AddAssetType";
import { useOrganisationContext, useUserContext } from "hooks";
import { ApiClient, } from "services";

const AssetTypesList = ({ match, t }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState('asset_types');
    const [assetTypes, setAssetTypes] = useState([]);
    const [assetAccounts, setAssetAccounts] = useState([]);
    const [newAssetType, setNewAssetType] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isStartDateModalOpen, setIsStartDateModalOpen] = useState(false);

    const { user } = useUserContext();
    const history = useHistory();

    const { selectedOrganisation } = useOrganisationContext();  
    const client = ApiClient();

    const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0;


    const userPermission = user?.groups[0]?.name === "Superuser" || user?.groups[0]?.name === "Superadmin";

    useEffect(() => {
        fetchAssetTypes();
        fetchAssetAccounts();
      }, []);

      const fetchAssetAccounts = async () => {
        try {
          const response = await client.get(`/xero/${connectedOrg}/accounts`);
          console.log(response, "====accounts \n===");
          setAssetAccounts(response.data);
        } catch (error) {
          NotificationManager.error(t("Error fetching asset accounts"));
          console.error(error);
        }
      };

    const fetchAssetTypes = async () => {
        try {
          const response = await client.get(`/asset-types/${connectedOrg}/assettypes`);
          console.log(response.data, "Asset Types");
          setAssetTypes(response.data)

        } catch (error) {
          NotificationManager.error(t("Error fetching asset types"));
          console.error(error);
        }
      };

      const handleAssetTypeSubmit = async (values) => {
    
          try {
              const response = await client.post(`/asset-types/${connectedOrg}/assettypes`, values);
              setAssetTypes([...assetTypes, response.data])
              NotificationManager.success(t("Asset Type submitted successfully"));
          } catch (error) {
              NotificationManager.error(t("Error submitting data"));
              console.error(error);
          }
          setNewAssetType('');
          toggleModal();
      };


    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const filteredAssetTpes = assetTypes?.filter(type =>
        type?.assetTypeName ? type?.assetTypeName.toLowerCase().includes(searchTerm.toLowerCase()) :
        type?.asset_account ? type?.asset_account.toLowerCase().includes(searchTerm.toLowerCase()) : "No data found"
    );

    const getAssetAccountName = (asset_type) => {
        const account = assetAccounts.find(account => account.AccountID === asset_type?.fixedAssetAccountId);
        return account ? account.Name : "No data found";
    };
    const getAccAccountName = (asset_type) => {
        const account = assetAccounts.find(account => account.AccountID === asset_type?.accumulatedDepreciationAccountId);
        return account ? account.Name : "No data found";
    };
    const getAcuExpAccountName = (asset_type) => {
        const account = assetAccounts.find(account => account.AccountID === asset_type?.depreciationExpenseAccountId);
        return account ? account.Name : "No data found";
    };
    
    const handleSaveAssetType = () => {
        setAssetTypes([...assetTypes, newAssetType]);
        setNewAssetType('');
        toggleModal();
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleStartDateModal = () => {
        setIsStartDateModalOpen(!isStartDateModalOpen);
    };

    


    const renderAssetTypesList = () => (
        <div className={styles.assetContainer}>
            <div className={styles.assetHeader}>
                <input
                    className={styles.searchBar}
                    type="search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder={t("Search Asset Types...")}
                />
            </div>
            <Table size="sm" className="small">
                <thead>
                    <tr>
                        <th><Trans>Asset Type</Trans></th>
                        <th><Trans>Asset Account</Trans></th>
                        <th><Trans>Accumulated Depreciation Account</Trans></th>
                        <th><Trans>Depreciation Expense Account</Trans></th>
                    </tr>
                </thead>
                <tbody>
                    {filteredAssetTpes.length > 0 ? (
                        filteredAssetTpes.map((asset, index) => (
                            <tr key={index}>
                                <td>{asset?.assetTypeName}</td>
                                <td>{getAssetAccountName(asset)}</td>
                                <td>{getAccAccountName(asset)}</td>
                                <td>{getAcuExpAccountName(asset)}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4"><Trans>No data found</Trans></td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );

    const renderAccountsForm = () => (
        <div className={styles.assetContainer}>
            <LocalForm>
            <Row>
            <Col md="6">
                <FormGroup>
                    <Label htmlFor="capitalGain"><Trans>Capital Gain on Disposal</Trans></Label>
                    <Control.select model=".capitalGain" id="capitalGain" className="form-control">
                        <option value=""><Trans>Select...</Trans></option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </Control.select>
                </FormGroup>
            </Col>

                <Col md="6">
                    <FormGroup>
                        <Label htmlFor="gainOnDisposal"><Trans>Gain on Disposal</Trans></Label>
                        <Control.select model=".gainOnDisposal" id="gainOnDisposal" className="form-control">
                            <option value=""><Trans>Select...</Trans></option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </Control.select>
                </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md="6">
                    <FormGroup>
                    <Label htmlFor="lossOnDisposal"><Trans>Loss on Disposal</Trans></Label>
                    <Control.select model=".lossOnDisposal" id="lossOnDisposal" className="form-control">
                        <option value=""><Trans>Select...</Trans></option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </Control.select>
                </FormGroup>
                </Col>
            </Row>
            <FormGroup>
            <Button type="submit" color="primary" className="btn btn-primary float-right">Save</Button>
            </FormGroup>

            
        </LocalForm>
        </div>
    );

    return (
        <Page title="Fixed Assets">
        <BackButton />
            <div className={` ${styles.asset_buttons}`}>
                <ul>
                    {userPermission && (
                        <>
                            <li>
                                <Button color="primary" className={``} onClick={toggleStartDateModal}><Trans>Change start date</Trans></Button>
                            </li>
                            <li>
                                <Button color="primary" className={``} onClick={toggleModal}>+ <Trans>Asset Type</Trans></Button>
                            </li>
                        </>
                    )}
                </ul>
            </div>
            <div className={` ${styles.navigation}`}>
                <ul>
                    {userPermission && (
                        <>
                            <li
                                onClick={() => handleTabChange('asset_types')}
                                className={activeTab === 'asset_types' ? styles.activeTab : ''}
                            >
                                <Trans>Asset Types</Trans>
                            </li>
                            {/* <li
                                onClick={() => handleTabChange('accounts')}
                                className={activeTab === 'accounts' ? styles.activeTab : ''}
                            >
                                <Trans>Accounts</Trans>
                            </li> */}
                        </>
                    )}
                </ul>
            </div>
            <>
                {activeTab === 'asset_types' && renderAssetTypesList()}
                {activeTab === 'accounts' && renderAccountsForm()}
            </>
            <AddAssetType isOpen={isModalOpen} toggle={toggleModal} onSave={handleAssetTypeSubmit} assetAccounts={assetAccounts} t={t} />


            {/* start date change modal */}
            <Modal isOpen={isStartDateModalOpen} toggle={toggleStartDateModal}>
            <Page title={t("Change Start Date")}>
                <LocalForm>
                        <Row form>
                            <Col md={12}>
                                <FormGroup label="Start date">
                                    <Control.text
                                        type="date"
                                        model=".start_date"
                                        className="form-control"
                                        id="start_date"
                                        style={{ backgroundColor: '#F4F7FE' }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleStartDateModal}><Trans>Cancel</Trans></Button>{' '}
                        <Button color="primary" type="submit"><Trans>Save</Trans></Button>
                    </ModalFooter>
                </LocalForm>
            </Page>
        </Modal>
        </Page>
    );
};

export default AssetTypesList;
